/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ColorConfigs from './colorconfig/colorconfig';
import ColorPreview from './colorpreview/colorpreview';
// styles
import injectSheet from 'react-jss';
import styles from './colorscheme_styles';



/* ========== ~~~~~~~~~~ COLOR SCHEME - SENTIMENT ~~~~~~~~~~ ========== */
const ColorScheme = injectSheet(styles)((props) => {
  return (
    <div className={props.classes.colorscheme}>
      <ColorConfigs {...props} />
      <ColorPreview {...props}/>
    </div>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ColorScheme;

